import script from "./HotelPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelPage.vue?vue&type=script&setup=true&lang=js"

import "./HotelPage.vue?vue&type=style&index=0&id=42a5d7b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a5d7b8"]])

export default __exports__